<template>
  <div class="fa-user-view">
    <div v-if="loading" style="padding: 20px; text-align: center;">
      <b-spinner/>
    </div>
    <template v-else>
      <!-- header -->
      <div class="fa-user-header">
        <div>
          <div class="fa-user-id">{{ userData.user_id }}</div>
          <div style="font-size: 12px; color: #888;">{{ userData.tenant_id }} · {{ userData.period }}</div>
        </div>
      </div>

      <!-- usage card -->
      <div class="fa-user-card">
        <div class="fa-stat">
          <div class="fa-stat-label">Blended cost</div>
          <div class="fa-stat-value">{{ formatCents(userData.blended_cost_cents) }}</div>
        </div>
        <div class="fa-stat">
          <div class="fa-stat-label">Chat / Docs</div>
          <div class="fa-stat-value">{{ userData.chat_requests || 0 }}<span class="fa-stat-sub"> / {{ userData.doc_categorizations || 0 }}</span></div>
        </div>
        <div class="fa-stat">
          <div class="fa-stat-label">Input tokens</div>
          <div class="fa-stat-value">{{ formatTokens(userData.input_tokens) }}</div>
        </div>
        <div class="fa-stat">
          <div class="fa-stat-label">Output tokens</div>
          <div class="fa-stat-value">{{ formatTokens(userData.output_tokens) }}</div>
        </div>
      </div>

      <!-- live session -->
      <div class="fa-section">
        <div class="fa-section-title">Live session</div>
        <div v-if="userData.live_session && userData.live_session.exists" class="fa-session-row" @click="$emit('open-session', { tenant_id: userData.tenant_id, user_id: userData.user_id, session_id: userData.live_session.session_id })">
          <div style="flex: 1;">
            <div style="font-weight: 600;">{{ (userData.live_session.turns || []).length }} turns</div>
            <div style="font-size: 12px; color: #888;">Updated {{ formatEpoch(userData.live_session.updated_at) }}</div>
          </div>
          <i class="fa fa-chevron-right" style="color: #888;"/>
        </div>
        <div v-else style="color: #888; font-size: 13px; padding: 8px;">No live session.</div>
      </div>

      <!-- archived sessions -->
      <div class="fa-section">
        <div class="fa-section-title">Archived sessions ({{ (userData.archived_sessions || []).length }})</div>
        <div v-if="(userData.archived_sessions || []).length > 0">
          <div v-for="s in userData.archived_sessions"
               :key="s.session_id"
               class="fa-session-row"
               @click="$emit('open-session', { tenant_id: s.tenant_id, user_id: s.user_id, session_id: s.session_id, archived: true })">
            <div style="flex: 1;">
              <div style="font-weight: 600;">{{ s.turn_count }} turns</div>
              <div style="font-size: 12px; color: #888;">Archived {{ formatEpoch(s.archived_at) }}</div>
            </div>
            <i class="fa fa-chevron-right" style="color: #888;"/>
          </div>
        </div>
        <div v-else style="color: #888; font-size: 13px; padding: 8px;">None yet.</div>
      </div>
    </template>
  </div>
</template>

<script>
import { formatCents, formatEpoch, formatTokens } from '../../helpers/fa_admin'

export default {
  name: 'FaUserView',
  props: {
    userData: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  methods: {
    formatCents,
    formatEpoch,
    formatTokens,
  },
}
</script>

<style scoped>
.fa-user-view { padding: 8px 0; }

.fa-user-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.fa-user-id {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.fa-user-card {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
}
.fa-stat { min-width: 120px; }
.fa-stat-label {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.fa-stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.fa-stat-sub {
  font-size: 13px;
  font-weight: normal;
  color: #888;
}

.fa-section { margin-top: 16px; }
.fa-section-title {
  font-size: 14px;
  font-weight: bold;
  color: steelblue;
  margin-bottom: 6px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 4px;
}
.fa-session-row {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 6px;
  cursor: pointer;
  background: #fff;
}
.fa-session-row:hover {
  background: #f9fafb;
  border-color: #c8d3dc;
}
</style>
